import { Component } from '@angular/core'

@Component({
  selector: 'app-risk-date-icon',
  templateUrl: './risk-date-icon.component.html',
  styleUrls: ['./risk-date-icon.component.scss'],
  standalone: true,
  imports: []
})
export class RiskDateIconComponent {
  constructor() {}
}
